import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, FormControl, InputLabel, Select,
} from '@mui/material';
import { useStyles } from './styles';
import Loader from '../../../commons/Loader';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';

export default function TypeSection({
  loader,
  types,
  inputData,
  setInputDataToSend,
}) {
  const classes = useStyles();
  const handleTypeSelectChange = ({ currentTarget }) => {
    const selectedType = currentTarget[currentTarget.selectedIndex].getAttribute('data-value');
    setInputDataToSend('type', selectedType);
    setInputDataToSend('panelDescription', '');
  };

  return (
    <Box className={classes.inputWrapper}>
      <FormControl variant="standard" className={classes.form}>
        <InputLabel id="type-label">Type</InputLabel>
        <Select
          disabled={loader.type}
          className={classes.typeInput}
          native
          onChange={handleTypeSelectChange}
          color="secondary"
          labelId="type-label"
          variant="standard"
          value={inputData.type || ''}
        >
          <option aria-label="None" />
          {types.uniqueAttributesValues?.map((type) => (
            <option data-value={type} key={type}>{type}</option>
          ))}
        </Select>
      </FormControl>
      <Loader target="type" offsetRight={48} size={18} centeredY />
    </Box>
  );
}

TypeSection.propTypes = {
  loader: PropTypes.objectOf(PropTypes.bool).isRequired,
  types: PropTypes.shape({
    uniqueAttributesValues: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  inputData: inputDataCustom.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
};
